import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    explore: [
      { label: 'AI角色扮演', href: '/category/jue-se-ban-yan' },
      { label: '虚拟恋人', href: '/category/xu-ni-lian-ren' },
      { label: '情感对话', href: '/category/qing-gan-dui-hua' },
      { label: '浪漫互动', href: '/category/lang-man-hu-dong' },
      { label: '心理陪伴', href: '/category/xin-li-pei-ban' },
      { label: '情趣探索', href: '/category/qing-qu-tan-suo' },
    ],
    about: [
      { label: '关于我们', href: '/about' },
      { label: '品牌故事', href: '/about#story' },
      { label: '用户口碑', href: '/about#testimonials' },
      { label: '联系我们', href: '/about#contact' },
    ],
    legal: [
      { label: '隐私政策', href: '/about#privacy' },
      { label: '使用条款', href: '/about#terms' },
      { label: '免责声明', href: '/about#disclaimer' },
    ],
  };

  return (
    <footer className="bg-secondary-50 border-t border-background-200/50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link
              to="/"
              className="flex items-center gap-2 text-xl font-bold font-heading text-foreground-950 mb-4"
            >
              <span className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-heart-line text-background-50 text-sm"></i>
              </span>
              AI风月
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              AI情感陪伴与风月互动体验平台。融合先进大语言模型，为你提供沉浸式情感对话、角色扮演与私密陪伴体验。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 rounded-full bg-background-100 flex items-center justify-center text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200" aria-label="微博" rel="nofollow">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-background-100 flex items-center justify-center text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200" aria-label="微信" rel="nofollow">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-background-100 flex items-center justify-center text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200" aria-label="小红书" rel="nofollow">
                <i className="ri-red-packet-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold font-heading text-foreground-950 mb-4">探索AI风月</h4>
            <ul className="space-y-2.5">
              {footerLinks.explore.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold font-heading text-foreground-950 mb-4">关于</h4>
            <ul className="space-y-2.5">
              {footerLinks.about.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold font-heading text-foreground-950 mb-4">法律信息</h4>
            <ul className="space-y-2.5">
              {footerLinks.legal.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-200/50 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {currentYear} AI风月. 保留所有权利.
          </p>
          <p className="text-xs text-foreground-500">
            AI情感陪伴平台 | 探索AI风月的无限可能
          </p>
        </div>
      </div>
    </footer>
  );
}